import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ValidationMessage } from "../../../../utils/constants/validationMessage";
import { integerInput, whiteSpaceCheck } from "../../../../helper/helper";
import PhoneInputField from "../../../../components/shared/FormFields/PhoneInputField";
import { regex } from "../../../../utils/constants/regexVariables";
// import { ValidationMessage } from "../../utils/constants/validationMessage";
// import { integerInput, whiteSpaceCheck } from "../../helper/helper";

const ContactPersoneInformation = ({
  register,
  errors,
  setValue,
  ContactPersonPhone,
  setContactPersonPhone,
}) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Contact Person Information</span>
      <Row className="mb-3 gx-sm-3 gx-2">
        <Col xl={4} md={4} xs={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Full Name"
              name="contactPersonName"
              {...register("contactPersonName", {
                required: ValidationMessage.CONTACT_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
            <ErrorMessage
              errors={errors}
              name="contactPersonName"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        <Col xl={4} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>
              Mobile No <span className="text-danger">*</span>
            </Form.Label>
            <PhoneInputField
              register={register}
              setValue={setValue}
              errors={errors}
              name="contactPersonMobile"
              validationMessage={ValidationMessage}
              regex={regex}
              countryCode="+91"
              initialPhone=""
              setPhone={setContactPersonPhone}
              phone={ContactPersonPhone}
              className={""}
            />
            <ErrorMessage
              errors={errors}
              name="contactPersonMobile"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>

        <Col xl={4} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>
              E-mail <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Email"
              name="contactPersonEmail"
              {...register("contactPersonEmail", {
                required: ValidationMessage.EMAIL_REQUIRED,
                pattern: {
                  value: regex.regEmail,
                  message: ValidationMessage.ENTER_VALID_EMAIL,
                },
              })}
            />

            <ErrorMessage
              errors={errors}
              name="contactPersonEmail"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default ContactPersoneInformation;
